var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"textData",staticClass:"text"},[(_vm.needEllips)?[_vm._t("default",function(){return [_c('el-tooltip',{attrs:{"effect":"dark","content":_vm.text,"placement":"top"}},[_c('span',[_vm._v(_vm._s(_vm.textData))])])]},{"text":_vm.textData})]:[_vm._v(_vm._s(_vm.textData))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }